






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { IAction } from "../common/CommonTypes";
import {
  LocationsApi,
  CustomersApi,
  GetLocationsResponse,
} from "../../../apis";
import * as moment from "moment";
import { DataOptions, DataTableHeader } from "vuetify";
import { ACTION } from "./index";
@Component({
  components: {
    MoreVertBtn,
  },
})
export default class AdminCustomerList extends Vue {
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  showDialog = false;
  locationSearch = "";
  selectedPermisstionId = "";
  selectedPermisstion = {} as any;
  // actions: Array<IAction> = [
  //   {
  //     titleName: "View Location",
  //     action: ACTION.VIEW_LOCATION,
  //   },
  // ];
  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("text.viewLocation"),
        titleStyle: "color: black; font-weight: 600",
        action: ACTION.VIEW_LOCATION,
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  headersLocation = [
    {
      text: "Customer Name",
      value: "customerName",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
    {
      text: "Location Name",
      align: "start",
      value: "locationName",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },

    {
      text: "Address",
      value: "address",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
    {
      text: "Contact",
      value: "contact",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
    {
      text: "Created Date",
      value: "createdDate",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
    {
      text: "Action",
      value: "action",
      class: ["tw-whitespace-no-wrap", "tw-p-4"],
    },
  ] as DataTableHeader[];
  tableLocationData = [] as any;
  locationResponse: GetLocationsResponse;
  // async beforeMount() {
  //   return await this.initData();
  // }
  locationSearchRespone: GetLocationsResponse;

  async initData() {
    this.doSearch();
  }

  async onSearch() {
    if (this.locationSearch.trim().length == 0) {
      return await this.initData();
    }
    this.doSearch();
  }
  formatDate(date: Date) {
    return moment(date).format("D MMM, YYYY");
  }
  onSelectedPermission(item, action): void {
    this.selectedPermisstion = { ...item };
    switch (action) {
      case ACTION.VIEW_LOCATION: {
        this.navigateDetail();
        break;
      }
      case ACTION.EDIT_LOCATION: {
        this.navigateEdit();
        break;
      }
      default: {
        break;
      }
    }
  }

  checkStatusAction() {
    return this.ACTIONS.filter((val) => val.action);
  }
  navigateDetail() {
    const id = this.selectedPermisstion.id;
    this.selectedPermisstionId = id;
    return this.$router.push({
      path: `/customers/locations/location-detail/${id}`,
    });
  }

  navigateEdit() {
    const id = this.selectedPermisstion.id;
    this.selectedPermisstionId = id;
    return this.$router.push({
      path: `/customers/locations/edit-location/${id}`,
    });
  }

  toggle() {
    return this.$router.push({
      path: `/customers/locations/location-detail/`,
    });
  }
  addUnit(): void {
    this.showDialog = false;
  }
  // mounted() {
  //   this.doSearch();
  // }
  toggleLocation(item) {
    const id = item.id;
    this.$router.push(`/customers/locations/location-detail/${id}`);
  }

  onPagingOption() {
    this.doSearch();
  }
  async doSearch() {
    this.$util.showLoading();
    try {
      await new LocationsApi()
        .getLocationsPaging({
          limit: this.pagingOption.itemsPerPage,
          keySearch: this.locationSearch,
          page: this.pagingOption.page,
          orderBy:
            this.pagingOption.sortBy.length > 0
              ? this.pagingOption.sortBy[0]
              : "createdAt",
          orderDesc:
            this.pagingOption.sortDesc.length > 0
              ? "" + this.pagingOption.sortDesc[0]
              : "true",
        })
        .then((locationData) => {
          const data = locationData.data.data;
          this.totalItems = locationData.data.count;
          this.tableLocationData = data.map((location) => {
            const item = {
              id: location.id,
              locationName: location.locationName,
              address: location.address,
              contact: location.contact,
              unit: location.unit,
              createdDate: location.createdDate,
              editedDate: location.editedDate,
              customerId: location.customerId,
              customerName: location.customerName,
            };
            return item;
          });
        });
    } finally {
      this.$util.hideLoading();
    }
  }

  async getCustomerName(idCus: string) {
    const cusData = await new CustomersApi().getCustomerById({ id: idCus });
  }
}
